const roleAccess = {


  1: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  2: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  3: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  4: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  5: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  6: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  7: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  8: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar'],
  9: ['Home',  'Inbox', 'Timeline' ,'Calendar', 'Meetings', 'My Tasks', 'Timesheets', 'Leave', 'Teams', 'Expenses', 'Polls', 'Pull Requests', 'Holiday Calendar']

};

const HOME_SUB_MENU =
  [
    {
      label: 'Home',
      key: '/home/feed',
      icon:'HomeOutlined'
    },
    {
      label: 'Inbox',
      key: '/home/inbox',
      icon:'InboxOutlined'
    },
    {
      label: 'Timeline',
      key: '/home/timeline',
      icon:'EventsOutlined'
    },
    // {
    //   label: 'My Tasks',
    //   key: '/home/mytask',
    //   icon:'IssuesOutlined'
    // },
    {
      label: 'Calendar',
      key: '/home/schedule',
      icon:'CalendarOutlined'
    },
    {
      label: 'Meetings',
      key: '/home/evently',
      icon: 'SupportPortalOutlined'
    },
    {
      label: 'Timesheets',
      key: '/home/mytimesheets',
      icon:'MeetingsOutlined'

    },
    {
      label: 'Polls',
      key: '/home/polls',
      icon:'PollOutlined'
    },{

      label: 'Leave',
      key: '/home/leave',
      icon:'PlaneOutlined'
    },
    {
      label: 'Teams',
      key: '/home/myteams',
      icon:'UsersOutlined'
    }
    // {
    //   label: 'Pull Requests',
    //   key: '/home/prs',
    //   icon:'TreeOutlined'
    // },
    // {
    //   label: 'Holiday Calendar',
    //   key: '/home/reports',
    //   icon:'CalendarOutlined'
    // }
  ];
  
function getHomeMenuForRoles(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus.add(item));
  });
  return HOME_SUB_MENU.filter(menuItem => accessibleMenus.has(menuItem.label));
}

  
export {
  getHomeMenuForRoles
};
  